import { createAction, props } from '@ngrx/store';
import { TTSRawTextOptions } from '@mhe/reader/models';

export const loadTextAudio = createAction(
  'Annotation Context Menu: Load Text Audio',
  props<{ options: TTSRawTextOptions }>(),
);

export type AnnotationsContextMenuActions = ReturnType<typeof loadTextAudio>;
